module.exports = __webpack_public_path__ + "img/arrow-down.ca167435.svg";